import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-youtube-icon",
  "use": "icon-youtube-icon-usage",
  "viewBox": "0 0 38 28",
  "content": "<symbol viewBox=\"0 0 38 28\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-youtube-icon\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.33298 0C2.38798 0 0 2.3878 0 5.3333V22.6666C0 25.6122 2.38798 28 5.33298 28H32C34.946 28 37.333 25.6122 37.333 22.6666V5.3333C37.333 2.3878 34.946 0 32 0H5.33298ZM13.55 20.8519L25.292 13.999L13.55 7.1461V20.8519Z\" fill=\"#A7F900\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol